import React, { useEffect,  useState } from "react";

import { Row, Col, Button, Offcanvas } from "react-bootstrap";
import ColourFilterBox from "../../../../components/FilterBox/ColourFilter/ColourFilter";
import { FiMenu } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import ColourTable from "../../../../components/Tables/ColourTable";
import {
  ColourFilter,
  MonthlyStockFun,
  MonthlyStock,
} from "../../../../Redux/Slice/Colour/InwardAnylysis/InwardAnylysis";
import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext";

export const MonthlyStockPage = () => {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { ColourfilterData, MonthlyStockdata } = useSelector(
    (state) => state.InwardAnylysisSlice,
  );

  console.log(DataMain);


  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICL",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");


  const parseFinancialYear = (fyString) => {
    if (!fyString) return {};

    const [start, end] = fyString.split(" - ");

    const formatDate = (dateStr) => {
      const [dd, mm, yyyy] = dateStr.split("/");
      return `${yyyy}-${mm}-${dd}`; // backend friendly
    };

    return {
      FromDate: formatDate(start),
      ToDate: formatDate(end),
    };
  };

  let matchedYear = null;

  DataMain?.AC_Year_List?.forEach((el) => {
    if (el.AcYearID === Number(FinancialYear)) {
      matchedYear = el.AcYear;
    }
  });

  const { FromDate, ToDate } = parseFinancialYear(matchedYear);

  console.log(FromDate);
  console.log(ToDate);



  const [showFilter, setShowFilter] = useState(false);

  const itemGroupList = ColourfilterData?.ItemGroup?.map((item) => ({
    label: item?.ItemGroupName,
    value: item?.ItemGroupID,
  }));

  const [filters, setFilters] = useState({
    itemGroup: [],
  });

  const [search, setSearch] = useState({
    itemGroup: "",
  });

  useEffect(() => {
    // if (!FromDate || !ToDate) return;

    dispatch(
      MonthlyStock({
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,
        StartDate: FromDate,
        EndDate: ToDate
      }),
    );
    dispatch(ColourFilter());
  }, [dispatch, Firm, FinancialYear]);

  const toggleItem = (type, item) => {
    setFilters((prev) => {
      const selected = prev[type];

      const updatedSelected = selected.includes(item.value)
        ? selected.filter((i) => i !== item.value)
        : [...selected, item.value];

      const newFilters = {
        ...prev,
        [type]: updatedSelected,
      };

      if (type === "itemGroup") {
        dispatch(MonthlyStockFun());

        dispatch(
          MonthlyStock({
            FirmIDs: Firm,
            AcYearIDs: FinancialYear,
            ItemGroupIDs: updatedSelected.join(","),
            StartDate: FromDate,
            EndDate: ToDate,
          })
        );
      }

      return newFilters;
    });
  };

  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);
    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, val) => {
    setSearch((prev) => ({ ...prev, [type]: val }));
  };

  const TableChartColumns = [
    { label: "Item Group", key: "ItemGroupName", colors: isdark === "light" ? "#000" : "#fff", align: "left" },
    { label: "Total", key: "Total", align: "right" },

    { label: "Apr", key: "AprStk", align: "right", format: true },
    { label: "May", key: "MayStk", align: "right", format: true },
    { label: "Jun", key: "JunStk", align: "right", format: true },
    { label: "Jul", key: "JulStk", align: "right", format: true },
    { label: "Aug", key: "AugStk", align: "right", format: true },
    { label: "Sep", key: "SepStk", align: "right", format: true },

    { label: "Oct", key: "OctStk", align: "right", format: true },
    { label: "Nov", key: "NovStk", align: "right", format: true },
    { label: "Dec", key: "DecStk", align: "right", format: true },

    { label: "Jan", key: "JanStk", align: "right", format: true },
    { label: "Feb", key: "FebStk", align: "right", format: true },
    { label: "Mar", key: "MarStk", align: "right", format: true },
  ];

  const TableChartRow = (MonthlyStockdata?.Detail || []).map((row) => ({
    ItemGroupName: row?.ItemGroupName?.trim() ?? "",
    ItemGroupId: row?.itemgroupid ?? "",

    AprStk: row?.AprStk,
    MayStk: row?.MayStk,
    JunStk: row?.JunStk,
    JulStk: row?.JulStk,
    AugStk: row?.AugStk,
    SepStk: row?.SepStk,
    OctStk: row?.OctStk,
    NovStk: row?.NovStk,
    DecStk: row?.DecStk,
    JanStk: row?.JanStk,
    FebStk: row?.FebStk,
    MarStk: row?.MarStk,
    Total: row?.Total,
  }));
  // 🔷 FILTER PANEL

  if (!ColourfilterData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!MonthlyStockdata || MonthlyStockdata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        minHeight: "100vh",
        padding: "16px",
      }}
    >


      {/* MOBILE BUTTON */}
      <div className="d-lg-none text-end mb-2">
        <Button
          onClick={() => setShowFilter(true)}
          style={{
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            border: "none",
          }}
        >
          <FiMenu />
        </Button>
      </div>

      {/* OFFCANVAS */}
      <Offcanvas show={showFilter} onHide={() => setShowFilter(false)}
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        }}
      >
        <Offcanvas.Header closeButton
          closeVariant={isdark === "dark" ? "white" : undefined}
          style={{ color: isdark === "light" ? "#000" : "#FFF", }} >
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <ColourFilterBox
              title="Item Group"
              items={itemGroupList}
              search={search.itemGroup}
              setSearch={(v) => handleSearch("itemGroup", v)}
              selectedItems={filters.itemGroup}
              toggleItem={(item) => toggleItem("itemGroup", item)}
              selectAll={() => selectAll("itemGroup", itemGroupList)}
            />
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Row>
        {/* DESKTOP FILTER */}
        <Col xl={3} lg={4} className="d-none d-lg-block">
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <ColourFilterBox
              title="itemGroup"
              items={itemGroupList}
              search={search.itemGroup}
              setSearch={(v) => handleSearch("itemGroup", v)}
              selectedItems={filters.itemGroup}
              toggleItem={(item) => toggleItem("itemGroup", item)} // ✅ FIX
              selectAll={() => selectAll("itemGroup", itemGroupList)} // ✅ FIX
            />
          </div>
        </Col>

        {/* TABLE */}
        <Col xl={9} lg={8} >
          <div
            style={{
              borderRadius: "14px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          >
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
              MONTHLY STOCK SUMMARY
            </div>

            <ColourTable columns={TableChartColumns} data={TableChartRow} />
          </div>
        </Col>
      </Row>
    </div>
  );
};
